import { object, string } from 'yup';

import { formatForWire } from 'utilities/common';

import { MAX_LENGTH_ERROR_MESSAGE } from 'modules/common/constants';

export default class Address {
  static schema = object().shape({
    city: string().max(40, MAX_LENGTH_ERROR_MESSAGE),
    stateCode: string().max(3, MAX_LENGTH_ERROR_MESSAGE),
    postalCode: string().max(10, MAX_LENGTH_ERROR_MESSAGE),
    countryCode: string().max(3, MAX_LENGTH_ERROR_MESSAGE),
  });

  constructor(wireData, countries = [], provinces = []) {
    const json = wireData || {};
    this.address1 = json.address1 || '';
    this.address2 = json.address2 || '';
    this.city = json.city || '';
    this.postalCode = json.postalCode || '';
    
    // V2 API uses provinceId and countryId (GUIDs)
    // Legacy API uses stateCode/countryCode (3-letter codes)
    // Convert from ID to code if needed
    if (json.provinceId && provinces.length > 0) {
      // Try both lowercase 'id' and uppercase 'Id' for V2 API compatibility
      const province = provinces.find(p => p.id === json.provinceId || p.Id === json.provinceId);
      this.stateCode = province ? province.code : (json.stateCode || '');
    } else {
      this.stateCode = json.stateCode || '';
    }

    if (json.countryId && countries.length > 0) {
      // Try both lowercase 'id' and uppercase 'Id' for V2 API compatibility
      const country = countries.find(c => c.id === json.countryId || c.Id === json.countryId);
      this.countryCode = country ? country.countryCode : (json.countryCode || '');
    } else {
      this.countryCode = json.countryCode || '';
    }
  }

  static fromWireData(wireData, countries = [], provinces = []) {
    return new Address(wireData, countries, provinces);
  }

  toWireData(countries = [], provinces = []) {
    // Convert codes back to GUIDs if needed for V2 API
    let countryId = null;
    let provinceId = null;

    // Lookup country GUID from countryCode
    if (this.countryCode && countries.length > 0) {
      const country = countries.find(c => 
        c.countryCode === this.countryCode || 
        c.CountryCode === this.countryCode
      );
      if (country) {
        countryId = country.id || country.Id;
      }
    }

    // Lookup province GUID from stateCode
    if (this.stateCode && provinces.length > 0) {
      const province = provinces.find(p => 
        p.code === this.stateCode || 
        p.Code === this.stateCode
      );
      if (province) {
        provinceId = province.id || province.Id;
      }
    }

    return formatForWire({
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      stateCode: this.stateCode,
      postalCode: this.postalCode,
      countryCode: this.countryCode,
      // Include GUIDs for V2 API
      countryId,
      provinceId,
    });
  }
}
